import React, { createContext, useContext, useState, useEffect } from 'react'

const ApiConfigContext = createContext()

export const useApiConfig = () => {
  const context = useContext(ApiConfigContext)
  if (!context) {
    throw new Error('useApiConfig must be used within an ApiConfigProvider')
  }
  return context
}

export const ApiConfigProvider = ({ children }) => {
  const [apiConfig, setApiConfig] = useState({
    supabaseUrl: 'https://iijqpznihnlpmsjtboyq.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlpanFwem5paG5scG1zanRib3lxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2OTA5MTEsImV4cCI6MjA3MTI2NjkxMX0.Tf7IhhZHcAEIuIVJyJk4TnGYII-7PccCPvRU0ILkY_c',
    devrevApiUrl: 'https://api.devrev.ai',
    devrevApiKey: 'your-devrev-api-key',
    claimsApiUrl: 'https://your-claims-api.com',
    claimsApiKey: 'your-claims-api-key',
    paymentApiUrl: 'https://your-payment-api.com',
    paymentApiKey: 'your-payment-api-key',
    notificationApiUrl: 'https://your-notification-api.com',
    notificationApiKey: 'your-notification-api-key'
  })

  const [isLoaded, setIsLoaded] = useState(true)

  const updateApiConfiguration = (newConfig) => {
    setApiConfig(newConfig)
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('apiConfiguration', JSON.stringify(newConfig))
      }
    } catch (error) {
      console.error('Error saving API configuration:', error)
    }
  }

  const getApiEndpoint = (service) => {
    switch (service) {
      case 'supabase':
        return {
          url: apiConfig.supabaseUrl,
          key: apiConfig.supabaseAnonKey
        }
      case 'devrev':
        return {
          url: apiConfig.devrevApiUrl,
          key: apiConfig.devrevApiKey
        }
      case 'claims':
        return {
          url: apiConfig.claimsApiUrl,
          key: apiConfig.claimsApiKey
        }
      case 'payment':
        return {
          url: apiConfig.paymentApiUrl,
          key: apiConfig.paymentApiKey
        }
      case 'notification':
        return {
          url: apiConfig.notificationApiUrl,
          key: apiConfig.notificationApiKey
        }
      default:
        return null
    }
  }

  const isConfigured = (service) => {
    const endpoint = getApiEndpoint(service)
    return endpoint && endpoint.url && endpoint.key && 
           endpoint.url !== '' && endpoint.key !== '' &&
           !endpoint.url.includes('your-') && !endpoint.key.includes('your-')
  }

  const getConfigurationStatus = () => {
    const services = ['supabase', 'devrev', 'claims', 'payment', 'notification']
    return services.map(service => ({
      service,
      configured: isConfigured(service)
    }))
  }

  const value = {
    apiConfig,
    updateApiConfiguration,
    getApiEndpoint,
    isConfigured,
    getConfigurationStatus,
    isLoaded
  }

  return (
    <ApiConfigContext.Provider value={value}>
      {children}
    </ApiConfigContext.Provider>
  )
}

export default ApiConfigContext